var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgBackArrow(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 17.884,
    height: 8.663,
    viewBox: "0 0 17.884 8.663",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "flecha-correcta",
    transform: "translate(17.884 140.663) rotate(180)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_5562",
    "data-name": "Grupo 5562",
    transform: "translate(0 132)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_16972",
    "data-name": "Trazado 16972",
    d: "M17.679,135.837h0l-3.65-3.633a.7.7,0,0,0-.986.99l2.451,2.439H.7a.7.7,0,0,0,0,1.4H15.494l-2.451,2.439a.7.7,0,0,0,.986.99l3.65-3.633h0A.7.7,0,0,0,17.679,135.837Z",
    transform: "translate(0 -132)",
    fill: "#151c45"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBackArrow);
export default __webpack_public_path__ + "static/media/back_arrow.f3781c30f2ca21c0b14dc546a2bd4b26.svg";
export { ForwardRef as ReactComponent };